import { DEVTOOLS_MODAL_CONTENT_ID, FLOATING_BAR_ID } from "../constants";

export const isDevToolsElement = (element: Element): boolean => {
  const floatingBar = document.getElementById(FLOATING_BAR_ID);
  const devToolsModal = document.getElementById(DEVTOOLS_MODAL_CONTENT_ID);

  return !!(
    (floatingBar && floatingBar.contains(element)) ||
    (devToolsModal && (devToolsModal === element || devToolsModal.contains(element)))
  );
};

// Helper to find the first DOM element in the fiber tree
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const findFirstDOMNode = (fiber: any): Element | null => {
  // If this fiber has a DOM node, return it
  if (fiber.stateNode instanceof Element) {
    return fiber.stateNode;
  }

  // If no DOM node, check the child
  if (fiber.child) {
    return findFirstDOMNode(fiber.child);
  }

  return null;
};
